import { render } from "./RiverComponent.vue?vue&type=template&id=6ec935c2"
import script from "./RiverComponent.vue?vue&type=script&lang=js"
export * from "./RiverComponent.vue?vue&type=script&lang=js"

import "./RiverComponent.vue?vue&type=style&index=0&id=6ec935c2&lang=css"

import exportComponent from "C:\\Users\\anton\\Desktop\\cangas_de_narcea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__